<template lang="pug">
.report-root
    general-title(
        title="关联分析",
        description="帮助您监控和分析特定页面的来源及去向，从而优化网站页面路径，改善网站质量",
        pos="right",
        :date="timeSpan"
    )
    .zone
        TableTitle(icon="fa fa-signal", title="关联页列表")
            small.table-title-tip （此站点共可设置20个关联页）
        .header-chart-line

        .zone-search
            a.btn.btn-icon.pull-right(@click="openNewAssoModal")
                i.fa.fa-plus-circle
                | 添加关联页
            input(
                placeholder="搜索内容...",
                v-model="tableQuery",
                @keyup.enter="pageNum = 1;searchTable()"
            )
            button.btn.btn-small.btn-primary(@click="pageNum = 1;searchTable()") 搜索

        table.data-table(style="table-layout: fixed")
            thead
                tr
                    th(width="40")
                    th(width="100%") 关联页名称
                    th(width="100%") 页面地址
                    th(width="100%") 创建日期
                    th(width="120") 操作
            tbody
                tr(
                    v-show="!isListLoading && tableList.length",
                    v-for="(item, index) in tableList.slice((pageNum - 1) * 4, (pageNum - 1) * 4 + 4)", :key="item.id"
                )
                    td {{index + 1}}
                    td {{item.title}}
                    td
                        a(:title="item.url | httpUrl")
                            | {{item.url | httpUrl}}
                    td {{item.createDate}}
                    td.operate-cell
                        i.fa.fa-eye.fa-lg(title="查看关联页", @click="showAssoInfo(item)")
                        i.fa.fa-trash-o.fa-lg(title="删除", @click="deleteAsso(item)")
                tr(v-show="!isListLoading && tableList.length === 0")
                    td(colspan="8", style="text-align: center;") 暂无数据
                tr(v-show="isListLoading")
                    td(colspan="8", style="text-align: center;")
                        img(src="//p.ssl.qhimg.com/t010aba4345b02168d6.gif")
        v-pagination(
            :total="totalListNum",
            :pn="pageNum",
            ps="4",
            @updatepage="onPageChange"
        )

    timeSpan(@change="onTimespanChange", filters="yesterday")

    div.sanky-chart-wrap
        a.btn {{currentItem && currentItem.title}}
        div.sanky-chart-mask(v-show="!sankyVisible")
        div#sankyChart(ref="sankyChart")
        .loadingchart(v-show="isSankyLoading")
    
    v-modal(:visible="modalVisible", title="添加关联页", @closemodal="modalVisible = false")
        .modal-content(style="min-width: 520px")
            div.form
                dl.item
                    dt.label 关联页名称
                    dd.control
                        input(class="size-normal", v-model="newAssoInfo.urlName", ref="urlNameInput", placeholder="请输入1-50字符名称")
                        em.error(v-show="newAssoError.urlName.len") 最多填写50个字符
                dl.item
                    dt.label 页面地址
                    dd.control
                        input(class="size-normal", v-model="newAssoInfo.url", ref="urlInput", placeholder="请输入URL 如：http://aaa.com")
                        em.error(v-show="!newAssoError.url.reg && newAssoError.url.len") 长度不得大于 1000
                        em.error(v-show="newAssoError.url.reg") 请输入正确格式的 URL
                        em.error(v-show="newAssoError.url.duplicate") 列表中已存在该地址
                dl.item
                    dt.label 匹配类型
                    dd.control
                        v-radio-group(
                            :options="[{title: '完全匹配', value: 1}, {title: '模糊匹配', value: 2}]",
                            v-model="newAssoInfo.matchtype"
                        )
        .btn-wrap
            input.btn.btn-primary.btn-medium(type="button", value="提交", @click="addNewAsso", :class="{disabled: !canSubmit}")
            input.btn.btn-default.btn-medium(type="button", value="取消", @click="modalVisible = false")
</template>

<script>
/* global _, echarts */
import Vue from 'vue'
import { getDateString } from '../../script/util'

const toPercent = Vue.filter('percent')
const RE_HTTP = /^https?:\/\/[a-zA-Z0-9][a-zA-Z0-9-]*\.[a-zA-Z0-9]+[^\s]*\s*$/
const defaultNewAssoInfo = {
  urlName: '',
  url: '',
  matchtype: 1
}

export default {
  data () {
    const today = getDateString.today()
    return {
      timeSpan: {
        start: today,
        end: today
      },
      tableQuery: '',
      tableList: [],
      totalListNum: 0,
      pageNum: 1,
      isListLoading: true,

      currentItem: null,

      sankyChart: null,
      isSankyLoading: false,
      resizeChart: _.throttle(() => {
        this.sankyChart && this.sankyChart.resize()
      }, 200),
      sankyVisible: false,

      modalVisible: false,
      newAssoInfo: _.cloneDeep(defaultNewAssoInfo),
      isSubmiting: false,

      timestamp: +new Date(),
      timer: null
    }
  },

  computed: {
    infoParams () {
      const { start, end } = this.timeSpan
      return {
        timespan: this.timestamp,
        id: this.currentItem && this.currentItem.id,
        start,
        end,
        cycle: start === end ? 'hour' : 'day',
        domainId: this.$store.state.domainId
      }
    },
    listParams () {
      return {
        domainId: this.$store.state.domainId,
        ps: 20,
        pg: 1
      }
    },
    newAssoError () {
      let { urlName, url } = this.newAssoInfo
      urlName = _.trim(urlName)
      url = _.trim(url)

      return {
        urlName: {
          len: urlName.length > 50,
          reg: false,
          empty: !urlName
        },
        url: {
          len: url.length > 1000,
          reg: url.length && !RE_HTTP.test(url),
          empty: !url,
          duplicate: _.findIndex(this.tableList, { url }) > -1
        }
      }
    },
    canSubmit () {
      const { url, urlName } = this.newAssoError
      return !(urlName.len || urlName.reg || urlName.empty || url.len || url.reg || url.empty || url.duplicate)
    }
  },

  watch: {
    listParams (newVal, oldVal) {
      if (newVal && newVal.domainId && !_.isEqual(newVal, oldVal)) {
        this.searchTable()
      }
    },
    infoParams (newVal, oldVal) {
      this.getAssoInfo()
    }
  },

  methods: {
    onTimespanChange (timespan) {
      this.timeSpan = timespan
    },
    onPageChange (num) {
      this.pageNum = num
      this.currentItem = this.tableList[(this.pageNum - 1) * 4]
    },

    searchTable () {
      if (!this.$store.state.domainId) {
        return
      }

      this.isListLoading = true
      this.tableList = []
      const params = _.extend({}, this.listParams, {
        url: this.tableQuery
      })

      this.$http.get('/api/associate/list', { params }).then(r => {
        return r.data || {}
      }).catch(e => {
        return {}
      }).then(data => {
        const { list = [], total = 0 } = data
        this.isListLoading = false
        this.totalListNum = total
        this.tableList = list
        this.currentItem = list[0]
      })
    },

    openNewAssoModal () {
      if (this.totalListNum >= 20) {
        this.$Modal.warn('超过限额，不能添加！')
      } else {
        this.newAssoInfo = _.cloneDeep(defaultNewAssoInfo)
        this.modalVisible = true
        this.$nextTick(() => {
          this.$refs.urlNameInput.focus()
        })
      }
    },
    addNewAsso () {
      if (this.canSubmit && !this.isSubmiting) {
        const info = this.newAssoInfo
        const domainId = this.$store.state.domainId

        const params = _.keys(info).reduce((accu, key) => {
          accu[key] = _.trim(`${info[key]}`)
          return accu
        }, { domainId })

        this.$http.get('/api/associate/add', { params }).then(res => {
          return res.data
        }).catch(e => {
          return null
        }).then(data => {
          this.isSubmiting = false

          if (data && data.errno === 0) {
            const result = data.data
            const newData = {
              createDate: getDateString.today(),
              domainId,
              id: result.id,
              matchtype: result.matchtype,
              title: result.urlName,
              url: result.url
            }

            this.modalVisible = false
            this.tableList.unshift(newData)
            this.totalListNum++
            this.pageNum = 1
            this.currentItem = this.tableList[0]
          } else {
            this.$Modal.warn(data && data.errmsg || '添加失败！')
          }
        })
      }
    },
    deleteAsso (item) {
      this.$Modal.confirm('确定删除？', (confirm) => {
        if (!confirm) return

        const isCurrentItem = this.currentItem === item
        this.$http.get('/api/associate/delete', {
          params: {
            domainId: this.$store.state.domainId,
            id: item.id
          }
        }).then(res => {
          const data = res.data
          if (data.errno === 0) {
            this.tableList.splice(_.indexOf(this.tableList, item), 1)
            this.totalListNum--
            if (isCurrentItem) {
              this.currentItem = this.tableList[0]
            }
          } else {
            this.$Modal.warn(data.errmsg)
          }
        }).catch(e => {
          this.$Modal.warn('删除失败')
        })
      })
    },

    showAssoInfo (item) {
      clearTimeout(this.timer)
      this.isSankyLoading = true
      this.timer = setTimeout(() => {
        this.timestamp = +new Date()
        this.currentItem = item
      }, 300)
    },

    getAssoInfo () {
      if (!this.infoParams.id) {
        return Promise.resolve(null)
      }

      const domain = this.$store.state.currentDomain.domain
      this.isSankyLoading = true
      this.$http.get('/api/associate/getinfo', {
        params: this.infoParams
      }).then(res => {
        return res.data
      }).then(data => {
        this.isSankyLoading = false
        if (!data || data.errno > 0) return
        const chartData = dealData(data, domain)
        this.drawSanky(chartData)
      }).catch(e => {
        console.log(e)
        return null
      })
    },

    drawSanky (data) {
      // this.sankyChart && this.sankyChart.dispose()
      this.sankyChart = echarts.init(this.$refs.sankyChart, null, {height: 500})
      this.sankyVisible = creatChart(data, this.sankyChart)
    }
  },
  mounted () {
    this.searchTable()
    Vue.$EventBus.$on('resize', this.resizeChart)
    window.addEventListener('resize', this.resizeChart, false)
  },
  destroyed () {
    Vue.$EventBus.$off('resize', this.resizeChart)
    window.removeEventListener('resize', this.resizeChart)
  }
}

// 处理数据函数
function dealData (sourceData, domain = '') {
  const origInfo = sourceData.info
  const info = _.extend({
    'cid': 0,
    'url': domain,
    'level': 0,
    'uniqid': 0,
    'funiqid': 0,
    'pv': 0,
    'epv': 0,
    'spv': 0,
    'outerrate': 0,
    'urlName': domain,
    'id': 1
  }, origInfo)

  let nodes = []
  const links = []
  const helper = {}
  const domainRe = new RegExp('https?:\/\/' + domain.replace(/\./g, '\\\.'))
  const basePath = info.url.replace(domainRe, '')

  helper[info.uniqid] = basePath
  nodes.push({
    name: basePath,
    path: basePath,
    url: info.url
  })

  sourceData.preList.forEach(item => {
    const path = item.url.replace(domainRe, '')
    nodes.push({
      name: `-1@${path}`,
      path,
      url: item.url
    })
    links.push({
      source: `-1@${path}`,
      target: basePath,
      value: +item.referPv || 0,
      url: item.url,
      path,
      statis: `来源量:${+item.referPv || 0}<br>占比: ${toPercent(+item.referPvRate || 0)}`
    })
  });

  ['nextListL1', 'nextListL2', 'nextListL3'].forEach((key, i) => {
    sourceData[key].forEach(item => {
      const path = item.url.replace(domainRe, '')
      const isOut = path.indexOf('离开') > -1
      nodes.push({
        name: `${i + 1}@${path}`,
        path,
        url: item.url,
        isOut
      })
      helper[item.uniqid] = `${i + 1}@${path}`
      links.push({
        source: helper[item.funiqid],
        target: `${i + 1}@${path}`,
        value: +item.referPv || 0,
        url: item.url,
        path,
        statis: '' +
          (isOut ? '' : `带来访问量:${+item.referPv || 0}<br>`) +
          (isOut ? '' : `浏览量:${+item.pv || 0}<br>`) +
          (`退出率:${toPercent(+item.outerrate || 0)}`)
      })
    })
  })

  nodes = _.uniqBy(nodes, 'name')
  return { nodes, links }
}

function creatChart (data, chart) {
  const isNotEmpty = data && data.nodes && data.nodes.length > 1 && data.links && data.links.length > 1
  if (isNotEmpty === false) {
    return false
  }
  chart.setOption({
    tooltip: {
      trigger: 'item',
      showDelay: 120,
      formatter: function (params) {
        const { dataType, data } = params
        if (dataType === 'node') {
          return params.data.url
        } else if (dataType === 'edge') {
          const { url, statis } = data
          return `${url}<br>${statis}`
        }
      }
    },
    series: [
      {
        type: 'sankey',
        layout: 'none',
        data: data.nodes,
        links: data.links,
        nodeGap: 16,
        label: {
          normal: {
            show: true,
            textStyle: {
              fontSize: '12'
            },
            formatter: function (params) {
              return params.data.path.slice(0, 20)
            }
          },
          emphasis: {
            show: true,
            textStyle: {
              color: '#333',
              fontSize: 14,
              fontWeight: 'bold'
            }
          }
        },
        itemStyle: {
          normal: {
            borderWidth: 0
          },
          emphasis: {}
        },
        lineStyle: {
          normal: {
            color: 'source',
            curveness: 0.6
          }
        }
      }
    ],
    backgroundColor: '#fff',
    color: ['#fe8463', '#9bca63', '#fad860', '#60c0dd', '#0084c6', '#d7504b', '#c6e579', '#26c0c0', '#f0805a', '#f4e001', '#b5c334']
  })

  return true
}
</script>

<style scoped>
@import '../../css/base/variables.css';

.zone {
    background: #fff;
    overflow: hidden;
    margin-bottom: 0;
}

.zone-search {
    padding: 0 23px 16px;
}
.table-title-tip {
    font-size: 12px;
    color: #999;
    margin-left: 5px;
}
.operate-cell .fa {
    margin-right: 5px;
}

.sanky-chart-wrap {
    position: relative;
    width: 100%;
    height: 500px;
    box-sizing: content-box;
    padding-bottom: 50px;
    background: #fff;
    & > a {
        position: absolute;
        bottom: 10px;
        left: 50%;
        z-index: 5;
        width: 500px;
        margin-left: -250px;
        overflow: hidden;
        text-align: center;
        font-size: 16px;
        font-weight: bold;
        white-space: nowrap;
        text-overflow: ellipsis;
        color: #7e7e7e;
    }
}
.sanky-chart-mask {
    position: absolute;
    z-index: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 500px;
    background: #fff url('//p2.ssl.qhimg.com/d/inn/b8c9e688/null.png') center no-repeat;
}
.loadingchart {
    z-index: 7;
    height: 500px;
}
</style>



// WEBPACK FOOTER //
// associate.vue?9d3b7396